import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MonoTypeOperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UtilsService {
  constructor(private translateService: TranslateService) {}

  public getTextAtPath(path: string): string | null {
    const currentLang = this.translateService.currentLang;
    const translations = this.translateService.store.translations[currentLang];

    if (!translations) {
      console.warn(`Translations not loaded for language: ${currentLang}`);
      return null;
    }

    const keys = path.split('.');
    let result = translations;

    for (const key of keys) {
      if (result[key] === undefined) {
        return null;
      }
      result = result[key];
    }

    return typeof result === 'string' ? result : null;
  }
}

export function isDefined(value: any): boolean {
  return value !== undefined && value !== null;
}

export function filterDefined<T>(): MonoTypeOperatorFunction<T> {
  return filter((value) => isDefined(value));
}
